import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-stretch">
      <div className="w-full lg:w-1/2 bg-background-50 flex items-center px-4 md:px-8 lg:px-16 py-20 lg:py-0">
        <div className="max-w-lg">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
            {t('hero_title_line1')}
            <br />
            {t('hero_title_line2')}
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
            {t('hero_subtitle')}
          </p>

          <div className="flex flex-wrap gap-3 mb-8">
            {categories.slice(0, 6).map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 bg-background-100 border border-background-200/70 rounded-full px-3 py-2 hover:border-primary-300 hover:bg-background-50 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-7 h-7 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={cat.thumbUrl}
                    alt={cat.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap font-label">
                  {cat.name}
                </span>
              </a>
            ))}
          </div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-label font-semibold text-sm px-7 py-4 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span>{t('hero_cta')}</span>
            <span className="w-7 h-7 flex items-center justify-center border border-background-50/40 rounded-full transition-transform duration-200 group-hover:translate-x-0.5">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>

      <div className="hidden lg:block w-1/2 bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Woman%20from%20behind%20carrying%20shopping%20bags%20walking%20through%20sunlit%20urban%20street%20with%20modern%20architecture%2C%20golden%20hour%20light%20creating%20long%20shadows%2C%20fashion%20lifestyle%20editorial%20photography%2C%20warm%20terracotta%20and%20cream%20palette%2C%20candid%20elegant%20moment%2C%20European%20city%20aesthetic&width=960&height=1200&seq=hero-lifestyle-v3&orientation=portrait"
          alt="HoobuySpreadsheet estilo de vida"
          title="HoobuySpreadsheet compras inteligentes"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}